import React from "react";

interface StatCardProps {
  label: string;
  value: number | string;
  icon: React.ReactNode;
}

const padTwo = (v: number | string): string => {
  if (typeof v === "string") return v;
  return String(v).padStart(2, "0");
};

export const StatCard: React.FC<StatCardProps> = ({ label, value, icon }) => (
  <div className="flex flex-1 flex-col gap-2 rounded-xl border border-neutral-200 bg-white p-4">
    <div className="flex items-start justify-between">
      <span className="font-medium text-neutral-400 text-xs uppercase tracking-wider">
        {label}
      </span>
      <span className="text-neutral-300">{icon}</span>
    </div>
    <p className="font-semibold text-3xl text-neutral-800">{padTwo(value)}</p>
  </div>
);
